/**
 * CTA fijo a la página de consultas (Tally @ consulta.delfuocampo.com).
 * Mismo botón bajo la galería del home (BaseTemplate) y en /portfolio.
 * El destino es fijo: no depende de site-settings ni de toggles del admin.
 */

import { ExternalLink } from "lucide-react";
import { useTranslation } from "react-i18next";
import { TALLY_CONTACT_PUBLIC_URL } from "@/components/templates/BaseTemplateTallyContact";
import { baseTemplateDarkShell } from "@/lib/baseTemplateDarkShell";
import { cn } from "@/lib/utils";

type Props = {
  /** dark = vidrio sobre fondo negro (home). light = borde sobre fondo claro. */
  variant?: "dark" | "light";
  onClick?: () => void;
  className?: string;
};

export function ConsultaCtaButton({ variant = "dark", onClick, className }: Props) {
  const { t } = useTranslation();
  const isDark = variant === "dark";

  return (
    <a
      href={TALLY_CONTACT_PUBLIC_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className={cn(
        isDark
          ? baseTemplateDarkShell.ctaGlass
          : "inline-flex items-center gap-3 py-4 px-6 max-w-[380px] mx-auto rounded-full border border-black/15 bg-black/[0.04] hover:bg-black/[0.07]",
        "group active:scale-[0.97] transition-transform duration-150",
        className,
      )}
    >
      <span
        className={cn(
          "font-body text-sm sm:text-[15px] font-semibold leading-tight tracking-normal",
          isDark ? "text-white" : "text-black",
        )}
      >
        {t("baseTemplate.gallery.consultaCta", {
          defaultValue: "Consultas y colaboraciones",
        })}
      </span>
      <ExternalLink
        className={cn(
          "h-4 w-4 flex-shrink-0 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5",
          isDark ? "text-white/70" : "text-black/60",
        )}
        aria-hidden
      />
    </a>
  );
}

export default ConsultaCtaButton;
